import { z } from 'zod'
import { guidSchema } from '../../contracts/_common'
import { bzOptional } from '../common-schemas'
import { ReviewTypeSchema } from './ReviewTypes'

const reviewLinkLabelSchema = z.string().trim().min(1).max(100)
const reviewPlatformIdSchema = z.string().trim().min(1)

export const CompanyReviewLinkSchema = z.object({
  companyReviewLinkGuid: guidSchema,
  companyGuid: guidSchema,
  label: reviewLinkLabelSchema,
  reviewType: ReviewTypeSchema,
  platformId: reviewPlatformIdSchema,
  sortOrder: z.number().int().min(0).default(0),
  isActive: z.boolean().default(true),
  isEligibleForTechnician: z.boolean().default(true),
  isDefault: z.boolean().default(false),
})

export type CompanyReviewLink = z.infer<typeof CompanyReviewLinkSchema>

export const CreateCompanyReviewLinkInputSchema = z.object({
  label: reviewLinkLabelSchema,
  reviewType: bzOptional(ReviewTypeSchema).default('GOOGLE'),
  platformId: reviewPlatformIdSchema,
  sortOrder: bzOptional(z.number().int().min(0)).default(0),
  isEligibleForTechnician: bzOptional(z.boolean()).default(true),
})

export type CreateCompanyReviewLinkInput = z.infer<typeof CreateCompanyReviewLinkInputSchema>

export const UpdateCompanyReviewLinkInputSchema = z.object({
  companyReviewLinkGuid: guidSchema,
  label: bzOptional(reviewLinkLabelSchema),
  platformId: bzOptional(reviewPlatformIdSchema),
  sortOrder: bzOptional(z.number().int().min(0)),
  isEligibleForTechnician: bzOptional(z.boolean()),
})

export type UpdateCompanyReviewLinkInput = z.infer<typeof UpdateCompanyReviewLinkInputSchema>
